export default "__VITE_ASSET__CRgatIRr__"